import axios from 'axios';
import handleApiError from '../handleApiError';
import { configEnv } from '@/shared/config-env';

const LIMIT = 50;

/**
 * @description Получить рейтинг участников программы лояльности.
 */
export async function getRating() {
  try {
    const { data } = await axios.get(
      `${configEnv.VUE_APP_LOYALTY_API_URL}/api/topClientsRating/${LIMIT}`,
    );
    return data.response;
  } catch (error) {
    handleApiError(error);
  }
}
